export const getCookie = (name: string) => {
    const matches = (document as any).cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const createCookie = (name: string, value: string, hours?: number) => {
    let expires = "";
    if (hours) {
        const date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date;
    } else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

export const eraseCookie = (name: string) => {
    createCookie(name, "", -100);
}